/**
 * TW Ingredients — mobile accordion; desktop keeps all rows expanded.
 *
 * Listeners are bound once per <details> element (data-tw-acc-bound), so
 * re-running bindSection after a scent switch (tw-ingredients:content-swapped)
 * never stacks duplicate handlers on panels that stay in the page. Stacked
 * click handlers used to toggle the "Full Ingredients" row an even number of
 * times, making it look unresponsive after every other scent switch.
 */
(function () {
  const MQ_DESKTOP = window.matchMedia('(min-width: 750px)');

  function syncSection(sectionEl) {
    const detailsList = sectionEl.querySelectorAll('.tw-ingredients-panel__item-details');
    detailsList.forEach((details) => {
      const alwaysAccordion = details.classList.contains(
        'tw-ingredients-panel__item-details--always-accordion'
      );
      if (MQ_DESKTOP.matches && !alwaysAccordion) {
        details.setAttribute('open', '');
        details.classList.add('tw-ingredients-panel__item-details--desktop');
      } else {
        details.classList.remove('tw-ingredients-panel__item-details--desktop');
        if (!details.hasAttribute('data-user-toggled')) {
          details.removeAttribute('open');
        }
      }

      // Leaving desktop width: clear the inline !important overrides the
      // desktop click handler sets on the "always accordion" item, so
      // mobile's native <details> behavior isn't fought by stale styles
      // left over from a desktop-width interaction earlier in the session.
      if (alwaysAccordion && !MQ_DESKTOP.matches) {
        const desc = details.querySelector('.tw-ingredients-panel__item-desc-mobile');
        const icon = details.querySelector('.tw-ingredients-panel__accordion-icon');
        if (desc) desc.style.removeProperty('display');
        if (icon) icon.style.removeProperty('transform');
      }
    });
  }

  function bindDetails(details) {
    // One set of listeners per element, however often the section is re-bound.
    if (details.dataset.twAccBound === 'true') return;
    details.dataset.twAccBound = 'true';

    const alwaysAccordion = details.classList.contains(
      'tw-ingredients-panel__item-details--always-accordion'
    );

    details.addEventListener('toggle', () => {
      if (!MQ_DESKTOP.matches || alwaysAccordion) {
        details.setAttribute('data-user-toggled', 'true');
      }
    });

    if (!alwaysAccordion) return;

    // Desktop only: drive the "always accordion" item's open/closed state
    // directly (inline !important styles), instead of leaning on the
    // native <details> toggle + CSS [open] selector, which — on this
    // section's desktop layout — was leaving the row stuck closed.
    const summary = details.querySelector('.tw-ingredients-panel__item-summary');
    const desc = details.querySelector('.tw-ingredients-panel__item-desc-mobile');
    const icon = details.querySelector('.tw-ingredients-panel__accordion-icon');
    if (!summary) return;

    summary.addEventListener('click', (event) => {
      if (!MQ_DESKTOP.matches) return;
      event.preventDefault();

      const willOpen = !details.hasAttribute('open');
      if (willOpen) {
        details.setAttribute('open', '');
        if (desc) desc.style.setProperty('display', 'block', 'important');
        if (icon) icon.style.transform = 'rotate(180deg)';
      } else {
        details.removeAttribute('open');
        if (desc) desc.style.setProperty('display', 'none', 'important');
        if (icon) icon.style.transform = '';
      }
      details.setAttribute('data-user-toggled', 'true');
    });
  }

  function bindSection(sectionEl) {
    if (sectionEl.dataset.twIngredientsAccordionBound === 'true') return;
    sectionEl.dataset.twIngredientsAccordionBound = 'true';

    sectionEl.querySelectorAll('.tw-ingredients-panel__item-details').forEach(bindDetails);

    // One media-query listener per section.
    if (sectionEl.dataset.twIngredientsMqBound !== 'true') {
      sectionEl.dataset.twIngredientsMqBound = 'true';
      const onMqChange = () => syncSection(sectionEl);
      if (MQ_DESKTOP.addEventListener) {
        MQ_DESKTOP.addEventListener('change', onMqChange);
      } else {
        MQ_DESKTOP.addListener(onMqChange);
      }
    }

    syncSection(sectionEl);
  }

  function init() {
    document.querySelectorAll('.tw-ingredients-section-wrapper').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('tw-ingredients-section-wrapper')) {
      bindSection(event.target);
    }
  });

  document.addEventListener('tw-ingredients:content-swapped', (event) => {
    const sectionEl = event.target.closest
      ? event.target.closest('.tw-ingredients-section-wrapper')
      : null;
    if (sectionEl) {
      delete sectionEl.dataset.twIngredientsAccordionBound;
      bindSection(sectionEl);
    }
  });
})();
